import { Component, Input, TemplateRef, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "app-table-chart",
    templateUrl: "./table-chart.component.html",
    styleUrls: ["./table-chart.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class TableChartComponent<T> {
    @Input() public title: string;
    @Input() public tooltip: string;
    @Input() public rows: Array<T>;
    @Input() public rowTemplate!: TemplateRef<{ $implicit: T }>;
    @Input() public headersTemplate: TemplateRef<unknown>;
    @Input() public headerExtraContent: TemplateRef<unknown>;
}
